import { dramas } from "@/mocks/dramas";
import { news } from "@/mocks/news";
import { specials } from "@/mocks/specials";
import type { Drama, NewsItem, Special } from "@/types";

export const getDramaById = (id: number): Drama | undefined =>
  dramas.find((d) => d.id === id);

export const getNewsById = (id: number): NewsItem | undefined =>
  news.find((n) => n.id === id);

export const getSpecialById = (id: number): Special | undefined =>
  specials.find((s) => s.id === id);

export const getDramasByIds = (ids: number[]): Drama[] =>
  ids
    .map((id) => getDramaById(id))
    .filter((d): d is Drama => Boolean(d));

export const getNewsByIds = (ids: number[]): NewsItem[] =>
  ids
    .map((id) => getNewsById(id))
    .filter((n): n is NewsItem => Boolean(n));

export const dramaGenres = [
  "全部",
  "爱情",
  "悬疑",
  "古装",
  "现代",
  "青春",
  "科幻",
  "治愈",
  "动作",
  "家庭",
  "医疗",
];

export const dramaYears = ["全部", "2025", "2024", "2023"];

export const ratingOptions = ["全部", "9.0以上", "8.5以上", "8.0以上"];

export const sortOptions = [
  { key: "hot", label: "按热度" },
  { key: "newest", label: "最新上线" },
  { key: "rating", label: "评分最高" },
] as const;

export type SortKey = (typeof sortOptions)[number]["key"];

export function sortDramas(list: Drama[], key: SortKey): Drama[] {
  const copy = [...list];
  if (key === "newest") return copy.sort((a, b) => b.year - a.year || b.hot - a.hot);
  if (key === "rating") return copy.sort((a, b) => b.rating - a.rating);
  return copy.sort((a, b) => b.hot - a.hot);
}

export function sortNews(list: NewsItem[], key: "newest" | "hot"): NewsItem[] {
  const copy = [...list];
  if (key === "newest")
    return copy.sort((a, b) => (a.date < b.date ? 1 : -1));
  return copy.sort((a, b) => b.id - a.id);
}

export interface SearchResult {
  dramas: Drama[];
  news: NewsItem[];
}

export function searchAll(keyword: string): SearchResult {
  const q = keyword.trim().toLowerCase();
  if (!q) return { dramas: [], news: [] };
  const match = (text: string) => text.toLowerCase().includes(q);
  return {
    dramas: dramas.filter(
      (d) =>
        match(d.title) ||
        d.genres.some(match) ||
        d.cast.some(match) ||
        d.tags.some(match) ||
        match(d.director)
    ),
    news: news.filter(
      (n) => match(n.title) || match(n.summary) || match(n.tag)
    ),
  };
}